import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EUserPermissions } from 'projects/ngx-messaging/src/modules/chat/interfaces/EPermissions';

import { AuthGuard } from '@app/core/services/auth.guard';

import { AuthResolver } from './core/services/auth.resolve';
import { LoginComponent } from './modules/auth/login/login.component';
import { ErrorScreenComponent } from './modules/error-screen/error-screen.component';
import { UrlGeneratorComponent } from './modules/url-generator/url-generator.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'away',
    canActivate: [AuthGuard],
    resolve: { result: AuthResolver },
    loadChildren: () => import('@app/modules/chat/pages/away-page/away-page.module').then((m) => m.AwayPageModule),
  },
  { path: 'error-screen', component: ErrorScreenComponent },
  {
    path: 'url-generator',
    component: UrlGeneratorComponent,
  },
  {
    path: 'settings',
    resolve: { result: AuthResolver },
    data: { permissions: [EUserPermissions.settings] },
    loadChildren: () => import('@app/modules/settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    resolve: { result: AuthResolver },
    loadChildren: () => import('@app/modules/chat/chat.module').then((m) => m.ChatModule),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
